import { css } from '@emotion/react';
import { Link, Stack, Typography } from '@mui/material';
import { ISourcingNewsItem } from '../../../schemas/SourcingListItems.schema';
import { colors } from '../../../theme/colors';
import { sectionCss, sectionTitleCss } from './sourcing-detail-panel.styles';

const emptyNewsCss = css`
  font-size: 12px;
  line-height: 1.66;
  color: ${colors.text.secondary};
  font-style: italic;
`;

const newsCardCss = css`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  border: 2px solid white;
  border-radius: 4px;
  background: ${colors.neutral[5]};
  box-shadow:
    0px 24px 48px 0px rgba(75, 82, 93, 0.02),
    0px 4px 24px 0px rgba(16, 37, 62, 0.04),
    0px -4px 40px 0px rgba(255, 255, 255, 0.06);
`;

const newsCardHeaderCss = css`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const newsSourceCss = css`
  font-size: 12px;
  line-height: 1.66;
  color: ${colors.text.main};
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const newsDateCss = css`
  font-size: 12px;
  line-height: 1.66;
  color: ${colors.text.secondary};
  flex-shrink: 0;
`;

const newsTitleCss = css`
  font-size: 12px;
  line-height: 1.66;
  color: ${colors.primary[60]};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export interface RecentNewsSectionProps {
  readonly news: readonly ISourcingNewsItem[];
}

export function RecentNewsSection({ news }: RecentNewsSectionProps) {
  return (
    <Stack css={sectionCss} gap='4px'>
      <Typography css={sectionTitleCss}>Recent News</Typography>
      <Stack gap='4px'>
        {news.length === 0 && <Typography css={emptyNewsCss}>No recent news</Typography>}
        {news.map((item) => (
          <NewsCard key={item.url} item={item} />
        ))}
      </Stack>
    </Stack>
  );
}

interface NewsCardProps {
  readonly item: ISourcingNewsItem;
}

function NewsCard({ item }: NewsCardProps) {
  return (
    <div css={newsCardCss}>
      <div css={newsCardHeaderCss}>
        <Typography css={newsSourceCss}>{item.source}</Typography>
        <Typography css={newsDateCss}>{item.date}</Typography>
      </div>
      <Link href={item.url} target='_blank' rel='noopener noreferrer' css={newsTitleCss} underline='hover'>
        {item.title}
      </Link>
    </div>
  );
}
